import { getDerivedVideoPath } from '../../utils/musicStreamUrls';

// 获取当前活动媒体元素（音频或视频）
export const getActiveMediaElement = (hasVideo, videoRef, audioRef) =>
  (hasVideo && videoRef?.current) ? videoRef.current : audioRef?.current;

// 获取视频文件路径（同目录推导）
export const getVideoFilePath = (music) => {
  try {
    return getDerivedVideoPath(music) || null;
  } catch (e) {
    console.warn('Failed to resolve video file path:', e);
    return null;
  }
};

// 格式化时间
export const formatTime = (seconds) => {
  if (!seconds || Number.isNaN(seconds)) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

